<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Worth the Weight</h1>
</div>
</div>
<h1>
	Worth the Weight</h1>
<h3>
<br/>
	Eileen Palma</h3>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap240817.vue?02a10060